import logoSrc from '../assets/brand/demandjet-logo.png';
import logoOnDarkSrc from '../assets/brand/demandjet-logo-on-dark.png';
import markOnDarkSrc from '../assets/brand/demandjet-mark-on-dark.png';

/** Intrinsic logo aspect ratio (width / height) for the full lockup. */
const LOGO_ASPECT = 1471 / 412;
/** Icon-only mark is square. */
const MARK_ASPECT = 1;

/**
 * DemandJet brand mark.
 * `variant`:
 *   - `default` — full lockup for light backgrounds
 *   - `onDark` — full lockup (white ink) for dark backgrounds
 *   - `markOnDark` — icon-only (D + flame) for dark backgrounds
 * `size` controls height in pixels; width scales with aspect ratio.
 */
export default function BrandMark({
  size = 48,
  className = '',
  alt = 'DemandJet',
  variant = 'default',
}) {
  const height = Number(size) || 48;
  const isMark = variant === 'markOnDark';
  const width = Math.round(height * (isMark ? MARK_ASPECT : LOGO_ASPECT));
  const src =
    variant === 'markOnDark'
      ? markOnDarkSrc
      : variant === 'onDark'
        ? logoOnDarkSrc
        : logoSrc;

  return (
    <img
      className={`brand-mark ${className}`.trim()}
      src={src}
      width={width}
      height={height}
      alt={alt}
      decoding="async"
    />
  );
}
